import React from 'react'

import { RecordOrView, RecordOrViewProps } from './RecordOrView'

export interface RecordOrViewWithSidebarProps extends Omit<RecordOrViewProps, 'withSidebar'> {}
export function RecordOrViewWithSidebar(props: RecordOrViewWithSidebarProps) {
  return <RecordOrView {...props} withSidebar />
}
